import { autoCapitalize } from '@/utils/autoCapitalize'
import { MedicalRecordProfessionalListData } from '@/modules/Telemedicine/pages/MedicalRecord/components/MedicalRecordFilter/MedicalRecordFilter.types'

class MedicalRecordProfessionalFilterMapper {
  toDomain(persistenceMedicalRecordlData: MedicalRecordProfessionalListData) {
    return {
      id: persistenceMedicalRecordlData?.id,
      name: autoCapitalize(persistenceMedicalRecordlData?.nome),
    }
  }
}

export default new MedicalRecordProfessionalFilterMapper()
